/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable new-cap */
/* eslint-disable react/prop-types */
import React, { useContext, useState } from "react";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import moment from "moment";
import ArticleIcon from "@mui/icons-material/Article";
import styles from "./ExportButton.styles";
import Button from "../../../../../components/Layout/Button/NewButton";
import { SERVICES } from "../../../../../components/Layout/Services";
import { post } from "../../../../../components/Layout/ApiHandler/apihandler";
import { ToastAlertContext } from "../../../../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../../Components/constant";

function ExportButtonForChapter({ data, selectedReport }) {
  const toast = useContext(ToastAlertContext);
  const location = useLocation();
  const handleExport = async () => {
    const queryParams = new URLSearchParams(location.search);
    const downloadData = {
      areaId: queryParams.get("areaId") || null,
      zoneId: queryParams.get("zoneId") || null,
      regionId: queryParams.get("regionId") || null,
      chapterId: queryParams.get("chapterId") || null,
      districtId: queryParams.get("districtId") || null,
      blockId: queryParams.get("blockId") || null,
      payableCity: queryParams.get("payableCity") || null,
      orderPaymentMethod: queryParams.get("orderPaymentMethod") || null,
      from: queryParams.get("from") || null,
      to: queryParams.get("to") || null,
    };
    let url;
    if (selectedReport === "Cheque Deposit List") {
      url = `${SERVICES.DOWNLOAD_CHAPTER_CHEQUES_BANK_DEPOSIT_SLIP}`;
    } else {
      url = `${SERVICES.DOWNLOAD_CHEQUES_DD_REPORTS}`;
    }
    try {
      const response = await post(url, downloadData);
      if (response.ok) {
        toast.show(
          "Reports Generation started successfully. Please check under Reports > Download section",
          AlertStatus.SUCCESS,
        );
      }
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const disabled = !data || !data.length;

  return (
    <Box style={{ ...styles.dropdown, ...(disabled ? styles.disabled : {}) }}>
      <Box>
        {" "}
        <Button
          variant="outlined"
          style={{
            ...styles.leftSideBtn,
            color: disabled ? "#000000" : "#00ADF8",
            border: disabled ? "1px solid #000000" : "1px solid #00ADF8",
          }}
          onClick={handleExport}
          label="Export to Excel"
          startIcon={
            <ArticleIcon
              sx={{
                fontSize: "18px",
                fontWeight: "100",
              }}
            />
          }
        />
      </Box>
    </Box>
  );
}

export default ExportButtonForChapter;
